export default __webpack_public_path__ + "static/timeline-image-01-754520e240c45f9ad5bcbd8c4b5a87f5.jpg";